import React from 'react';

import { VStack } from '../../core-ui';
import { UserPermissions as Permissions } from '../../types/shared/User';
import { defineGetters } from '../../support/defineGetters';

import UserPermissionSelect from './UserPermissionSelect';

type Props = {
  permissions: Permissions;
  onChange: (permissions: Permissions) => void;
};

const permissionToLabel = defineGetters<keyof Permissions>({
  users: () => t('Users'),
  vendors: () => t('Vendors'),
  billing: () => t('Billing'),
  metrics: () => t('Metrics'),
  attendance: () => t('Attendance'),
  formBuilder: () => t('Form Builder'),
  marketsAndPricing: () => t('Markets and Pricing'),
  marketSales: () => t('Market Sales'),
  marketPages: () => t('Market Pages'),
  vendorPlacement: () => t('Vendor Placement'),
  settings: () => t('Settings'),
});

export default function UserPermissions(props: Props) {
  const { onChange, permissions } = props;
  return (
    <VStack>
      {Object.keys(permissionToLabel).map((key) => (
        <UserPermissionSelect
          key={key}
          label={permissionToLabel[key]}
          value={permissions[key]}
          onChange={(value) => {
            onChange({ ...permissions, [key]: value });
          }}
        />
      ))}
    </VStack>
  );
}
